<template>
  <ControlGroup>
    <slot />
    <Dropdown
      v-if="countries"
      label="Country/region"
      :value="value"
      @input="handleInput"
      :options="[
        { label: 'World', value: 'World' },
        ...countries.map((country) => ({
          label: country.name,
          value: country.iso3,
        })),
      ]"
    />
    <slot name="after" />
  </ControlGroup>
</template>

<script>
import { ControlGroup, Dropdown } from "@international-energy-agency/vue-ui";
export default {
  components: {
    ControlGroup,
    Dropdown,
  },
  props: {
    /* For v-model binding */
    value: {
      type: String,
      required: true,
    },
    countries: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
    },
  },
};
</script>